export const SAMPLE_CHAT_QUESTIONS: string[] = [
  'Who has high blood sugar?',
  'What kind of data we have in our datasource?',
  'How many patients have diabetes?',
  'Show me the latest laboratory results of patients',
  'Which patients have high cholesterol levels, and what follow-up actions are recommended?',
  'Are there any patients with upcoming appointments who have critical lab results?',
  'List all patients who have not visited their primary doctor in the last year.',
  'What is the availability of Dr. William Salk for the next two weeks?',
  'Find patients with anemia and suggest possible treatment options.',
  'Which patients have diabetes and what are their latest HbA1c levels?',
  'Who are the patients with kidney function impairment, and what are the next steps?',
  'List all patients with upcoming follow-up appointments and their reasons.',
  'Which patients have not scheduled a follow-up appointment despite having abnormal lab results?'
];
